"use client"

import styled from "@emotion/styled"
import { Desktop, Mobile } from "@eurodrive/ui"
import Container from "@eurodrive/ui/Container"
import { Button, Typography } from "@mui/material"
import Image from "next/image"
import Link from "next/link"

const StyledGrid = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: 1fr;
  gap: 24px;
  padding-bottom: 60px;
  padding-top: 24px;
  ${({ theme }) => theme.breakpoints.up("md")} {
    grid-template-columns: 1fr 580px;
    gap: 140px;
    padding-bottom: 80px;
    padding-top: 80px;
  }
`

const ContentBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  margin: auto;
  order: 2;
  ${({ theme }) => theme.breakpoints.up("md")} {
    order: 1;
  }
`

const TextBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const ButtonContainer = styled.div`
  width: 100%;
  ${({ theme }) => theme.breakpoints.up("md")} {
    max-width: 328px;
  }
`

const ImageContainer = styled.div`
  position: relative;
  height: 400px;
  width: 100%;
  order: 1;
  ${({ theme }) => theme.breakpoints.up("md")} {
    order: 2;
  }
`
export default function NotFound() {
  return (
    <Container paddingMobile>
      <StyledGrid>
        <ContentBox>
          <TextBox>
            <Typography variant="h2">אופס, משהו השתבש</Typography>
            <Typography variant="body2">
              אפשר לנסות שוב
            </Typography>
          </TextBox>
          <ButtonContainer>
            <Button
              fullWidth
              variant="primary"
              size="large"
              href="/"
              LinkComponent={Link}
            >
              רענן
            </Button>
          </ButtonContainer>
        </ContentBox>
        <ImageContainer>
          <Mobile>
            <Image src="/small404.svg" alt="404" fill objectFit="none" />
          </Mobile>
          <Desktop>
            <Image src="/404.svg" alt="404" fill objectFit="none" />
          </Desktop>
        </ImageContainer>
      </StyledGrid>
    </Container>
  )
}
